import {
  useState,
  useEffect,
  useCallback,
  useMemo,
} from 'react';

function useResponsiveItemsPerPage() {
  const breakpoints = useMemo(() => [
    { minWidth: 1700, items: 14 },
    { minWidth: 1550, items: 12 },
    { minWidth: 1400, items: 10 },
    { minWidth: 1200, items: 8 },
    { minWidth: 992, items: 6 },
    { minWidth: 768, items: 4 },
    { minWidth: 0, items: 2 },
  ], []);

  const [itemsToShow, setItemsToShow] = useState(4);

  const updateItemsToShow = useCallback(() => {
    const width = window.innerWidth;
    const matchedBreakpoint = breakpoints.find(breakpoint => width >= breakpoint.minWidth);

    if (matchedBreakpoint) {
      setItemsToShow(matchedBreakpoint.items);
    }
  }, [breakpoints]);

  useEffect(() => {
    updateItemsToShow();

    window.addEventListener('resize', updateItemsToShow);

    return () => {
      window.removeEventListener('resize', updateItemsToShow);
    };
  }, [updateItemsToShow]);

  return itemsToShow;
}

export default useResponsiveItemsPerPage;
